/*
 * 功能模块的颜色变量配置
 */

import { ThemeColors } from '..';

export const paymentModalColor: ThemeColors = {
  color: {
    'payment-modal-tab-mark-text': 'var(--payment-modal-tab-mark-text)',
    'payment-modal-card-link-color': 'var(--payment-modal-card-link-color)',
    'payment-modal-card-link-hover-color': 'var(--payment-modal-card-link-hover-color)',
    'payment-modal-card-title-color': 'var(--payment-modal-card-title-color)',
    'payment-modal-tab-text': 'var(--payment-modal-tab-text)',
    'payment-modal-tab-active-text': 'var(--payment-modal-tab-active-text)',
    'payment-modal-card-text-color': 'var(--payment-modal-card-text-color)',
    'payment-modal-card-text-secondary': 'var(--payment-modal-card-text-secondary)',
  },
  backgroundColor: {
    'payment-modal-bg': 'var(--payment-modal-bg)',
    'payment-modal-title-bg': 'var(--payment-modal-title-bg)',
    'payment-modal-tab-bg': 'var(--payment-modal-tab-bg)',
    'payment-modal-card-item-bg': 'var(--payment-modal-card-item-bg)',
    'payment-modal-tab-item-bg': 'var(--payment-modal-tab-item-bg)',
    'payment-modal-card-active-corner-bg': 'var(--payment-modal-card-active-corner-bg)',
    'payment-modal-slider-bg': 'var(--payment-modal-slider-bg)',
    'payment-modal-slider-track': 'var(--payment-modal-slider-track)',
  },
  borderColor: {
    'payment-modal-card-active-color': 'var(--payment-modal-card-active-color)',
    'payment-modal-tab-border': 'var(--payment-modal-tab-border)',
  },
};
